import { TOPIC_CATEGORIES } from '../../types'

interface Props {
  value: string | null
  onChange: (category: string) => void
}

export default function CategoryDropdown({ value, onChange }: Props) {
  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className="w-full px-3 py-2 border border-[#351E1D]/20 rounded-lg text-text-primary focus:outline-none focus:border-charcoal focus:ring-2 focus:ring-charcoal/15"
      style={{ fontSize: '16px' }}
    >
      <option value="">No category</option>
      {TOPIC_CATEGORIES.map(c => (
        <option key={c.value} value={c.value}>{c.label}</option>
      ))}
    </select>
  )
}
